'use client';

import { useLayoutEffect } from 'react';
import type { ThemeStyle } from '@/stores/calendar-store';

const THEME_KEY = 'vacant-day-theme-style';
const DEFAULT_THEME: ThemeStyle = 'sunlit-atlas';

export function PageThemeDefault({ theme }: { theme: ThemeStyle }) {
  useLayoutEffect(() => {
    const saved = localStorage.getItem(THEME_KEY);
    if (saved) return; // user has explicit preference — respect it

    document.documentElement.setAttribute('data-style', theme);

    return () => {
      // Restore app default on unmount (navigation away)
      const current = localStorage.getItem(THEME_KEY);
      if (!current) {
        document.documentElement.setAttribute('data-style', DEFAULT_THEME);
      }
    };
  }, [theme]);

  return null;
}
